import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingComponent } from '@app/admin/manage/modals/loading-component/loading.component';
import { RequestCount } from '@app/generated-api';
import {
    MdsButtonComponent,
    MdsCardComponent,
    MdsCardContentComponent,
} from '@medpacesoftwaredevelopment/designsystem';

@Component({
    selector: 'medpace-request-dashboard-card2',
    templateUrl: './request-dashboard.component.html',
    imports: [MdsButtonComponent, LoadingComponent, MdsCardComponent, MdsCardContentComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedpaceRequestDashboardCard2Component {
    private readonly router = inject(Router);

    travelCount = computed(() => {
        const requestsCount = this.requestsCount();
        return requestsCount.filter((f) => f.requestType === 'Travel')[0]?.total;
    });

    stipendCount = computed(() => {
        const requestsCount = this.requestsCount();
        return requestsCount.filter((f) => f.requestType === 'Stipend')[0]?.total;
    });

    reimbursementCount = computed(() => {
        const requestsCount = this.requestsCount();
        return requestsCount.filter((f) => f.requestType === 'Reimbursement')[0]?.total;
    });

    requestsCount = input.required<RequestCount[]>();

    goToTable(): void {
        this.router.navigate(['/requests']);
    }
}
